import { useNavigate } from "@tanstack/react-router"

import { AppStackIcon, Button, Empty } from "@productlane/ui"

import { useStartTrial } from "@/lib/use-start-trial"
import { useTrial } from "@/lib/useTrial"

export const Paywall = () => {
	const { hasTrialEnded, isScalePlan, hadRecentCancellation } = useTrial()
	const { startTrial, isStartingTrial } = useStartTrial()
	const navigate = useNavigate()

	if (!hasTrialEnded || isScalePlan) {
		return null
	}

	return (
		<div className="absolute inset-0 z-40 bg-white/90 backdrop-blur-sm dark:bg-black/90">
			<div className="absolute inset-0 flex flex-col items-center justify-center">
				<Empty
					variant="left"
					title="Trial has ended"
					text="Please upgrade to continue using Productlane."
					image={<AppStackIcon />}
					action={
						<div className="flex items-center gap-3">
							<Button
								size="lg"
								isLoading={isStartingTrial}
								onClick={() => {
									if (hadRecentCancellation) {
										void navigate({ to: "/settings/plans" })
										return
									}
									void startTrial()
								}}
							>
								{hadRecentCancellation ? "View plans" : "Restart 7-day trial"}
							</Button>
							<Button
								onClick={() => {
									// @ts-expect-error Global widget calls
									// eslint-disable-next-line
									window.Productlane.open("feedback")
								}}
								variant="outline"
								size="lg"
							>
								Contact us
							</Button>
						</div>
					}
				/>
			</div>
		</div>
	)
}
